<template>
  <div class="row bg-light border-bottom">
    <div class="col-12 px-5">
      
      <!-- Filtres -->
      <div class="row align-items-start bg-light py-3">
        <div class="col">
          <search-filters :filters="activeFilters" @submit.prevent="searchCustomers" />
        </div>
        
        <div class="col-lg-auto col-1">
          <div class="row">
            <div class="col-lg-6 col-12 mb-3">
              <button type="submit" class="btn btn-primary" form="search">Rechercher</button>
            </div>
            <div class="col-lg-6 col-12 text-end">
              <a class="btn btn-secondary dropdown-toggle" href="#" role="button" @click="toggleFilterDropdown">
                Critères
              </a>
              <div v-if="showFilterDropdown" class="dropdown-menu show position-fixed end-0 mt-3 me-3 p-3">
                <div class="form-check" v-for="filter in filters" :key="filter.field">
                  <input class="form-check-input" type="checkbox" v-model="filter.active" />
                  <label class="form-check-label mt-1" :for="filter.field">{{ filter.label }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row overflow-y-auto">
    <div class="col-12 overflow-y-auto px-5 pt-5" style="max-height: 70vh;">
      <div v-if="search.loading" class="row h-100">
        <loader />
      </div>
      <div v-else-if="search.customers.length" class="row">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th scope="col" @click="sortByColumn('source')" role="button">Source</th>
              <th scope="col" @click="sortByColumn('id')" role="button">Numéro de client</th>
              <th scope="col" @click="sortByColumn('firstname')" role="button">Prénom</th>
              <th scope="col" @click="sortByColumn('lastname')" role="button">Nom</th>
              <th scope="col" @click="sortByColumn('email')" role="button">Adresse e-mail</th>
              <th scope="col" @click="sortByColumn('dob')" role="button">Date de naissance</th>
              <th scope="col" @click="sortByColumn('postcode')" role="button">Code postal</th>
              <th scope="col" @click="sortByColumn('created_at')" role="button">Date d'inscription</th>
            </tr>
          </thead>
          <tbody class="table-group-divider">
            <tr v-for="customer in sortedCustomers" :key="customer.id">
              <td class="py-3">
                <img :src="sourceIcon(customer.store_id)" alt="Logo" width="24" height="24" />
              </td>
              <td class="py-3">
                <router-link :to="'/customers/' + customer.id" class="text-black text-decoration-none">
                  {{ customer.id }}
                </router-link>
              </td>
              <td class="py-3">{{ customer.firstname }}</td>
              <td class="py-3">{{ customer.lastname }}</td>
              <td class="py-3">
                <router-link :to="'/customers/' + customer.id" class="text-black text-decoration-none">
                  {{ customer.email }}
                </router-link>
              </td>
              <td v-if="customer.dob" class="py-3">{{ customer.dob }}</td>
              <td v-else class="py-3">-</td>
              <td v-if="customer.addresses && customer.addresses.length > 0" class="py-3">{{ customer.addresses[0].postcode }}</td>
              <td v-else class="py-3">-</td>
              <td class="py-3">{{ formatDate(customer.created_at).date }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="col text-center">
        <p>Aucun client n'a été trouvé.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatDate, sourceIcon } from '@/utils/tools';
import SearchFilters from '@/components/common/SearchFilters';

export default {
  components: {
    SearchFilters,
  },
  data() {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); 
    const day = today.getDate().toString().padStart(2, '0');

    const start = `${year}-${month}-${day}`;
    const end = `${year}-${month}-${day}`;
    
    return {
      showFilterDropdown: false,
      filters: [
        { field: 'created_at', label: 'Plage de dates', type: 'date', active: true, value: [start, end], condition: 'range' },
        { field: 'store_id', label: 'Source', type: 'select', condition: 'in', active: true, value: [], options: [], name: 'boutiques'},
        { field: 'entity_id', label: 'Numéro de client', type: 'text', active: true, value: '', condition: 'eq' },
        { field: 'customer_email', label: 'Adresse e-mail', type: 'text', active: true, value: '', condition: 'like' },
        { field: 'customer_firstname', label: 'Prénom', type: 'text', active: true, value: '', condition: 'eq' },
        { field: 'customer_lastname', label: 'Nom', type: 'text', active: true, value: '', condition: 'eq' },
      ],
      sortBy: 'created_at', // Champ de tri par défaut
      sortDesc: true,       // Tri descendant par défaut
    };
  },
  computed: {
    ...mapGetters('search', ['search']),
    activeFilters() {
      return this.filters.filter(filter => filter.active);
    },
    sortedCustomers() {
      let customers = [...this.search.customers];
      const compare = (a, b) => {
        const field = this.sortBy;
        if (a[field] < b[field]) return this.sortDesc ? 1 : -1;
        if (a[field] > b[field]) return this.sortDesc ? -1 : 1;
        return 0;
      };
      return customers.sort(compare);
    }
  },
  methods: {
    formatDate, 
    sourceIcon,
    ...mapActions('search', ['fetchCustomers']),
    toggleFilterDropdown() {
      this.showFilterDropdown = !this.showFilterDropdown;
    },
    async searchCustomers() {
      const filters = this.filters.reduce((acc, filter) => {
        if (filter.active && filter.value && filter.value.length) {
          if (filter.type === 'select' && Array.isArray(filter.value)) {
            acc[filter.field] = { value: filter.value.map(option => option.value).join(','), condition: 'in' };
          } else {
            acc[filter.field] = { value: filter.value, condition: filter.condition };
          }
        }
        return acc;
      }, {});
      await this.fetchCustomers({ filters });
    },
    sortByColumn(column) {
      if (this.sortBy == column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    }
  },
  mounted() {
    if (!this.search.customers.length) {
      this.searchCustomers();
    }
  }
};
</script>

<style scoped>
::-webkit-scrollbar {
  display: block;
  width: 10px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 ::-webkit-scrollbar-thumb {
  background: #888; 
}
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}</style>